import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./CalendarItem.module.css";

/**Displays information about calendar events. (All Item dates will be the same color). */
export function CalendarItem({ onClick, eventDetails, index }) {
  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.odd)}
    >
      <div className={classNames(styles.item, styles.date)}>
        {eventDetails.date}
      </div>
      <div className={styles.item}>{eventDetails.time}</div>
      <div className={styles.item}>{eventDetails.location}</div>
      <div className={styles.item}>{eventDetails.name}</div>
      <div
        className={classNames(styles.item, styles.view)}
        onClick={() => onClick(eventDetails)}
      >
        View
      </div>
    </div>
  );
}

CalendarItem.propTypes = {
  /**Function called when view is clicked */
  onClick: PropTypes.func,
  /**Object with details about the event (date-String, time-String, location-String, name-String)*/
  eventDetails: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
    location: PropTypes.string,
    name: PropTypes.string,
  }),
  /**Used to decide the background color */
  index: PropTypes.number,
};
